import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import NetworkSearchComponent from './network_search';
import StringUtils from '../utils/string';

const ConversationCreator = ({
  updateHasState,
  visible,
  closeConversationCreator,
  disabled,
  createConversation,
   ...props
 }) => {

  if (!visible) { return null; }

  const [participants, setParticipants] = useState(props.participants);
  const [message, setMessage] = useState('');
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    const _hasState = hasState();

    if (_hasState !== props.hasState) {
      updateHasState(_hasState);
    }

    if (!visible && _hasState) {
      clearState();
    }
  });

  const handleMessageChange = e => {
    setMessage(e.target.value);
  }

  const errorDisplay = () => {
    if (!errors.length) { return null; }

    return (
      <div>
        {errors.map((error, i) => {
          return <p className="new-conversation-error text-danger" key={i}>{error}</p>;
        })}
      </div>
    );
  }

  const tooltipText = () => {
    return `To add a participant, start typing their name, email address,
      or company name. Available contacts* will appear as you type.
      Add multiple participants to create a group chat.</br></br>
      *Note you can only message people with whom you've attended a Voray event.`;
  }

  const hasState = () => {
    return !!(
      participants.length ||
      message.length ||
      errors.length
    );
  }

  const clearState = () => {
    setParticipants([]);
    setMessage('');
    setErrors([]);
  }

  const closeComponent = (e) => {
    e.preventDefault();
    closeConversationCreator({ transitionRoute: true });
  }

  const disableSubmit = () => {
    return disabled ||
          !participants.length ||
          !StringUtils.trim(message).length;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const participantIds = participants.map(participant => { return participant.value; });
    const body = message;
    const data = { participant_ids: participantIds, message: { body: body } };

    createConversation(data).fail(function (jqXHR) {
      if (jqXHR.status === 422) {
        handleErrors(jqXHR.responseJSON.errors);
      } else if (jqXHR.status === 404) {
        setErrors(['User not found.']);
      }
    });
  }

  const handleErrors = errors => {
    const errorDetails = [];

    $.each(errors, (index, error) => {
      if (error.source && error.source.id) {
        errorDetails.push(error.detail);
      } else {
        errorDetails.push(`Message ${error.detail}`);
      }
    });

    setErrors(errorDetails);
  }

  return (
    <section className="col-md-9 col-md-offset-3 conversation-creator">
      <div className="conversation-creator-container">
        <form>
          {errorDisplay()}

          <div className="form-group">
            <label className="t3 w3">Participants</label>
            <i className="fa fa-info-circle text-blue1 ml-5"
              aria-hidden="true"
              data-toggle="tooltip"
              data-placement="right"
              data-html="true"
              data-delay="200"
              title={tooltipText()}></i>
            <NetworkSearchComponent initialUsers={participants} onTokenChange={setParticipants} />
          </div>

          <div className="form-group">
            <label className="t3 w3">Message</label>
            <textarea
              className="t3 form-control"
              rows="4"
              draggable="false"
              name="conversation_message[body]"
              onChange={handleMessageChange} />
          </div>

          <div className="form-buttons mb-20 clearfix">
            <button className="btn-main pull-right"
              onClick={handleSubmit}
              disabled={disableSubmit()}>Send</button>
            <button className="btn-main pull-right mr-10" onClick={closeComponent}>Cancel</button>
          </div>
        </form>
      </div>
    </section>
  );
}

ConversationCreator.propTypes = {
  visible: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  hasState: PropTypes.bool.isRequired,
  participants: PropTypes.array.isRequired,
  createConversation: PropTypes.func.isRequired,
  closeConversationCreator: PropTypes.func.isRequired,
  updateHasState: PropTypes.func.isRequired
};

export default ConversationCreator;
